import { Modal as M } from "react-bootstrap";
import { useGeneralAppStore } from "../../store/generalAppStore";

const ModalCustom = ({
  colorHeader = null, bgHeader = null,
  bg = null, padding = null, size, show, onHide, setShow, title, footer, children, loading, fullscreen = null, backdrop = null }) => {
  const hide = () => setShow(false);
  const { modals } = useGeneralAppStore()


  return (
    <M
      fullscreen={fullscreen}
      show={show}
      onHide={onHide ?? hide}
      size={size ? size : "lg"}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{
        backgroundColor: modals.length > 1 && modals[0] === 'acta_detalle' ? 'rgba(0,0,0,0.4)' : '',
        // opacity: modals.length > 1 && modals[0] === 'acta_detalle' ? '.1' : '1',        
      }}
    >
      <M.Header style={{ color: colorHeader && colorHeader, backgroundColor: bgHeader && bgHeader }} closeButton>
        <M.Title id="contained-modal-title-vcenter ">{!loading && title()}</M.Title>
      </M.Header>
      <M.Body className={`${(padding != null) && `p-${padding}`}`} style={{ backgroundColor: bg && bg }}>{children}</M.Body>
      {footer && <M.Footer>{!loading && footer()}</M.Footer>}
    </M>
  );
};

export default ModalCustom;
